import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeadersService, environment } from '@perval/shared';
import { firstValueFrom } from 'rxjs';
import { Plot } from '../models/plot';

interface PlotHttp {
  iris_code: string;
  total_area: number;
  buildings: any[];
  bbox: number[];
}

@Injectable({
  providedIn: 'root',
})
export class GeoService {
  private readonly mainUrl = `${environment.baseApiUrl}/perval-geo/cadastres`;

  constructor(
    private readonly http: HttpClient,
    private readonly httpHeadersServiceService: HttpHeadersService,
  ) {}

  async getCadastre(plotRef: string): Promise<Plot> {
    const response = await firstValueFrom(
      this.http.get<PlotHttp>(`${this.mainUrl}/${plotRef}/data`, {
        headers: await this.httpHeadersServiceService.getHeadersWithPervalContext(),
      }),
    );

    return {
      irisCode: response.iris_code,
      totalArea: response.total_area,
      buildings: response.buildings,
      bbox: response.bbox,
    };
  }
}
